import { render, staticRenderFns } from "./SelectPlanModal.vue?vue&type=template&id=5188737e&scoped=true&"
import script from "./SelectPlanModal.vue?vue&type=script&lang=ts&"
export * from "./SelectPlanModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPlanModal.vue?vue&type=style&index=0&id=5188737e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188737e",
  null
  
)

export default component.exports